const TrainingandDevelopment = () => {
  return (
    <div>
      <div className="bg-[#efefef] flex justify-center items-center h-[150px]">
        <h1 className="sm:text-[40px] text-[25px] font-bold">
          Training & Development
        </h1>
      </div>
      <div className="px-8 text-[#373737] my-12">
        <div className="max-w-[70rem] mx-auto flex flex-col md:flex-row md:gap-8">
          {/* Text Section */}
          <div className="md:flex-1 md:px-6">
            <p>
              The most important force behind every TCS operation is our human
              resource. All our people are provided with the career development
              channels as paths of progress. Hands-on training, constant
              coaching, certified modules, and specialist industrial trainings
              are part of our frontline staff’s training programmes, covering
              all aspects such as SOPs, personal grooming, etiquettes, shipment
              handling, road safety, etc. Management development programmes
              focus more on training the trainer, mentoring, best practices,
              people’s development, health & safety, and other soft skills.
            </p>
            <p className="pt-8">
              These programmes aid in developing specialised skills required for
              successfully running and managing Express and Logistics
              operations. A yearly system of appraisals and a performance review
              helps maintain the ever increasing level of required competence.
            </p>
          </div>

          {/* Image Section */}
          <div className="md:flex-1 mt-6 md:mt-0 flex justify-center items-center px-4">
            <img
              src="/Home/trainingdevelop/training-1.jpg"
              alt="Training"
              className="w-full max-w-[400px] h-auto object-cover  shadow-md"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainingandDevelopment;
